import { useMemo } from "react"

import { useTabBarContext } from "../context/TabBarContext"

export interface UseTabBarTabContainerViewModelProps {
  eventKey: string
}

export function useTabBarTabContainerViewModel({
  eventKey
}: UseTabBarTabContainerViewModelProps) {
  const { isSelected } = useTabBarContext()

  const selected = useMemo(() => isSelected(eventKey), [isSelected, eventKey])

  return useMemo(
    () => ({
      dndRef: null,
      dndAttributes: {} as Record<string, unknown>,
      dndListeners: undefined,
      isDragging: false,
      insertBefore: false,
      insertAfter: false,
      selected
    }),
    [selected]
  )
}
